import React, { useEffect, useState, useRef } from "react";

import { languageService } from "./lang/Lang.js";

import { connect } from "react-redux";
import { compose } from "redux";

import { sendmsg, getUser, getmessagesreal, guestLogin } from "../store/actions/homeActions";
import PIGU from "../assets/images/favicon.svg";

import io from 'socket.io-client';

import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';

import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

import { Redirect } from 'react-router-dom';

const URL = process.env.REACT_APP_WEBSOCKET_URL || "https://ws.pigu.chat";
const socket = io(URL, { autoConnect: false });

// Styles
const styles = {
  pageWrapper: {
    background: "#fff",
    height: "100dvh",
    paddingTop: "70px",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 16px",
    display: "flex",
    gap: "24px",
    height: "100%",
  },
  containerMobile: {
    flexDirection: "column",
    height: "100%",
    padding: "0",
  },
  // Chat section
  chatSection: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    background: "#fff",
    borderRadius: "12px",
    overflow: "hidden",
  },
  chatSectionDesktop: {
    flex: "1",
    maxWidth: "700px",
    margin: "16px auto",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    border: "1px solid #e8e8e8",
  },
  // Messages area
  messagesArea: {
    flex: 1,
    overflowY: "auto",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    WebkitOverflowScrolling: "touch",
    background: "#fafafa",
  },
  // Message bubbles
  messageBubble: {
    maxWidth: "80%",
    padding: "12px 16px",
    borderRadius: "18px",
    fontSize: "0.95em",
    lineHeight: "1.5",
    wordWrap: "break-word",
  },
  incomingMessage: {
    alignSelf: "flex-start",
    background: "#DCF3FF",
    color: "#333",
    borderBottomLeftRadius: "4px",
  },
  outgoingMessage: {
    alignSelf: "flex-end",
    background: "#FD8092",
    color: "#fff",
    borderBottomRightRadius: "4px",
  },
  messageRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
  },
  avatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  // Typing indicator
  typingIndicator: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 0",
  },
  typingDots: {
    display: "flex",
    gap: "4px",
  },
  typingDot: {
    width: "8px",
    height: "8px",
    background: "#FD8092",
    borderRadius: "50%",
    animation: "bounce 1.4s infinite ease-in-out",
  },
  // Input area
  inputArea: {
    padding: "12px 16px",
    borderTop: "1px solid #e8e8e8",
    background: "#fff",
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  inputWrapper: {
    flex: 1,
    position: "relative",
  },
  textInput: {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #e0e0e0",
    borderRadius: "24px",
    fontSize: "1em",
    outline: "none",
    background: "#f8f9fa",
    transition: "border-color 0.2s, box-shadow 0.2s",
  },
  sendButton: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    border: "none",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    transition: "transform 0.2s, box-shadow 0.2s",
  },
  // Credits bar
  creditsBar: {
    padding: "10px 16px",
    background: "linear-gradient(135deg, #f8f9ff 0%, #e8f4f8 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",
    borderTop: "1px solid #e8e8e8",
  },
  creditsBarWarning: {
    background: "linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%)",
  },
  creditsText: {
    fontSize: "0.85em",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  premiumButton: {
    fontSize: "0.8em",
    color: "#667eea",
    fontWeight: "600",
    padding: "6px 12px",
    background: "#fff",
    borderRadius: "6px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    border: "none",
    cursor: "pointer",
  },
};

function Chat(props) {
  const { profile, messages, loggedin, userdata, getUserFN, sendmsgFN, getmessagesrealFB, guestLoginFN } = props;

  const [content, setContent] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [secretPremium] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("sc") === "Ke45G97Z5";
  });

  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const popupRef = useRef();

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const canSendMessage = () => {
    if (secretPremium) return true;
    if (!userdata || userdata.length === 0) return false;
    return userdata[0].premium === 1 || userdata[0].credito > 0;
  };

  const handleSend = () => {
    if (!content.trim()) return;
    
    if (!canSendMessage()) {
      return popupRef.current.open();
    }

    sendmsgFN(profile.id, 0, content);
    setContent("");
    
    // Scroll immediately after sending
    setTimeout(scrollToBottom, 100);
    
    setTimeout(() => {
      getUserFN(profile.id);
      getmessagesrealFB(profile.id);
    }, 500);

    setTimeout(() => {
      setIsTyping(true);
    }, 1500);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };



  // Resize handler
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle mobile keyboard resize
  useEffect(() => {
    if (window.visualViewport) {
      const onViewportResize = () => {
        setTimeout(scrollToBottom, 100);
      };
      window.visualViewport.addEventListener('resize', onViewportResize);
      return () => window.visualViewport.removeEventListener('resize', onViewportResize);
    }
  }, []);

  // Scroll when messages change
  useEffect(() => {
    if (messages && messages.length > 0) {
      setTimeout(scrollToBottom, 100);
    }
  }, [messages]);

  // Scroll when typing indicator appears
  useEffect(() => {
    if (isTyping) {
      setTimeout(scrollToBottom, 100);
    }
  }, [isTyping]);

  // Socket handlers
  useEffect(() => {
    socket.on('connect', () => {});
    socket.on('disconnect', () => {});
    socket.on('pong', () => {});

    socket.on('pm', () => {
      setTimeout(() => setIsTyping(false), 1000);
      setTimeout(() => getmessagesrealFB(profile.id), 1500);
    });

    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off('pong');
      socket.off('pm');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Initial setup
  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    if (searchParams.get("status") === "success") {
      ReactGA.event({ category: "User", action: "Premium" });
      ReactPixel.track("Purchase", null);
    }

    socket.auth = { username: profile.id };
    socket.connect();
    getUserFN(profile.id);
    getmessagesrealFB(profile.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto guest login when secret code is present
  useEffect(() => {
    if (secretPremium && !loggedin) {
      guestLoginFN("Ke45G97Z5");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secretPremium, loggedin]);

  if (!loggedin && !secretPremium) return <Redirect to="/login" />;
  if (!loggedin && secretPremium) return <div style={styles.pageWrapper}><div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100vh"}}><p>Loading...</p></div></div>;

  const hasCredits = userdata && userdata.length > 0 && userdata[0].credito > 0;
  const isPremium = secretPremium || (userdata && userdata.length > 0 && userdata[0].premium === 1);

  return (
    <div style={styles.pageWrapper}>
      {/* CSS for typing animation */}
      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1); }
        }
        .typing-dot-1 { animation-delay: -0.32s; }
        .typing-dot-2 { animation-delay: -0.16s; }
        .typing-dot-3 { animation-delay: 0s; }
        .prompt-card:hover {
          border-color: #667eea !important;
          background-color: #f8f9ff !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
        }
        .send-btn:hover {
          transform: scale(1.05);
          box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
        }
        .text-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }
      `}</style>

      <div style={{
        ...styles.container,
        ...(isMobile ? styles.containerMobile : {})
      }}>
        {/* Chat Section */}
        <div style={{
          ...styles.chatSection,
          ...(isMobile ? {} : styles.chatSectionDesktop)
        }}>
          {/* Messages */}
          <div style={styles.messagesArea}>
            <div style={{ flex: 1 }} />
            {messages && messages.length > 0 ? (
              messages.map((message) => (
                <div 
                  key={message.id} 
                  style={{
                    ...styles.messageRow,
                    justifyContent: message.from === 0 ? "flex-start" : "flex-end",
                  }}
                >
                  {message.from === 0 && (
                    <img src={PIGU} alt="Sahra" style={styles.avatar} />
                  )}
                  <div style={{
                    ...styles.messageBubble,
                    ...(message.from === 0 ? styles.incomingMessage : styles.outgoingMessage)
                  }}>
                    {message.content}
                  </div>
                </div>
              ))
            ) : (
              <div style={styles.messageRow}>
                <img src={PIGU} alt="Sahra" style={styles.avatar} />
                <div style={{ ...styles.messageBubble, ...styles.incomingMessage }}>
                  {languageService.translate('chat.t2')}
                </div>
              </div>
            )}

            {/* Typing indicator */}
            {isTyping && (
              <div style={styles.messageRow}>
                <img src={PIGU} alt="Sahra" style={styles.avatar} />
                <div style={{ ...styles.messageBubble, ...styles.incomingMessage, padding: "16px 20px" }}>
                  <div style={styles.typingDots}>
                    <div className="typing-dot-1" style={styles.typingDot}></div>
                    <div className="typing-dot-2" style={styles.typingDot}></div>
                    <div className="typing-dot-3" style={styles.typingDot}></div>
                  </div>
                </div>
              </div>
            )}

            <div ref={messagesEndRef} />
          </div>

          {/* Credits bar for non-premium users */}
          {!isPremium && userdata && userdata.length > 0 && (
            <div style={{
              ...styles.creditsBar,
              ...(hasCredits ? {} : styles.creditsBarWarning)
            }}>
              <span style={{
                ...styles.creditsText,
                color: hasCredits ? "#555" : "#c53030"
              }}>
                {hasCredits ? "💬" : "⚠️"} {hasCredits 
                  ? `${userdata[0].credito} ${languageService.translate('settings.t3')}`
                  : languageService.translate('chat.t4')
                }
              </span>
              <form
                action={`${process.env.REACT_APP_API_URL || "https://ar.sahra.ai/api"}/stripe`}
                method="POST"
                style={{ display: "inline" }}
              >
                <input type="hidden" name="session_id" value={userdata[0].id} />
                <input type="hidden" name="email" value={userdata[0].email} />
                <button type="submit" style={styles.premiumButton}>
                  {languageService.translate('chat.t3')}
                </button>
              </form>
            </div>
          )}

          {/* Input area */}
          <div style={styles.inputArea}>
            <div style={styles.inputWrapper}>
              <input
                ref={inputRef}
                type="text"
                className="text-input"
                style={styles.textInput}
                placeholder={languageService.translate('chat.t10')}
                value={content}
                onChange={(e) => setContent(e.target.value)}
                onKeyPress={handleKeyPress}
                onFocus={() => setTimeout(scrollToBottom, 300)}
              />
            </div>
            <button 
              className="send-btn"
              style={styles.sendButton}
              onClick={handleSend}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </button>
          </div>
        </div>

      </div>

      {/* Paywall Popup */}
      <Popup
        ref={popupRef}
        contentStyle={{ borderRadius: "12px", maxWidth: "480px", padding: 0 }}
      >
        <div style={{ 
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          padding: "40px 30px 30px",
          borderRadius: "12px 12px 0 0",
          textAlign: "center"
        }}>
          <img src={PIGU} alt="Sahra" style={{ width: "100px", height: "100px" }} />
          <h2 style={{ 
            color: "#fff", 
            fontSize: "1.8em", 
            fontWeight: "700", 
            marginBottom: "10px",
            lineHeight: "1.2"
          }}>
            {languageService.translate('chat.paywall_title')}
          </h2>
          <p style={{ 
            color: "rgba(255,255,255,0.9)", 
            fontSize: "1em", 
            fontWeight: "400",
            marginBottom: "20px"
          }}>
            {languageService.translate('chat.paywall_subtitle')}
          </p>
          
          <div style={{
            display: "inline-block",
            background: "#48c774",
            color: "#fff",
            padding: "8px 20px",
            borderRadius: "20px",
            fontSize: "0.9em",
            fontWeight: "600",
            marginBottom: "15px"
          }}>
            ✨ {languageService.translate('chat.paywall_trial')}
          </div>
        </div>

        <div style={{ padding: "30px", background: "#fff" }}>
          <div style={{ marginBottom: "25px" }}>
            {[1, 2, 3, 4, 5].map(num => (
              <div key={num} style={{ 
                display: "flex", 
                alignItems: "flex-start", 
                marginBottom: "15px",
                color: "#333"
              }}>
                <div style={{
                  minWidth: "24px",
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  background: "#48c774",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "12px",
                  marginTop: "2px"
                }}>
                  <span style={{ color: "#fff", fontSize: "0.8em", fontWeight: "700" }}>✓</span>
                </div>
                <span style={{ 
                  fontSize: "1em", 
                  lineHeight: "1.5",
                  color: "#333",
                  textAlign: "left"
                }}>
                  {languageService.translate(`chat.paywall_feature_${num}`)}
                </span>
              </div>
            ))}
          </div>

          <form action={`${process.env.REACT_APP_API_URL || "https://api.pigu.chat"}/stripe`} method="POST">
            <input type="hidden" name="session_id" value={userdata && userdata.length > 0 ? userdata[0].id : null} />
            <input type="hidden" name="email" value={userdata && userdata.length > 0 ? userdata[0].email : null} />

            <button 
              type="submit"
              style={{
                width: "100%",
                border: 0,
                padding: "18px 20px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "#fff",
                borderRadius: "8px",
                fontSize: "1.1em",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                marginBottom: "15px"
              }}
            >
              {languageService.translate('chat.paywall_cta')} →
            </button>
            
            <p style={{ 
              textAlign: "center", 
              color: "#666", 
              fontSize: "0.85em",
              marginBottom: "15px"
            }}>
              🛡️ {languageService.translate('chat.paywall_guarantee')}
            </p>
            
            <p 
              style={{ 
                textAlign: "center", 
                color: "#999", 
                fontSize: "0.9em",
                cursor: "pointer",
                fontWeight: "500"
              }}
              onClick={() => popupRef.current.close()}
            >
              {languageService.translate('chat.paywall_dismiss')}
            </p>
          </form>
        </div>
      </Popup>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loggedin: state.home.loggedin,
    convs: state.home.convs,
    notifiche_list: state.home.notifiche_list,
    profile: state.home.profile,
    userdata: state.home.userdata,
    messages: state.home.messages,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserFN: (id) => dispatch(getUser(id)),
    sendmsgFN: (stuff, stuff2, stuff3) => dispatch(sendmsg(stuff, stuff2, stuff3)),
    getmessagesrealFB: (stuff, stuff2) => dispatch(getmessagesreal(stuff, stuff2)),
    guestLoginFN: (sc) => dispatch(guestLogin(sc)),
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Chat);
